import React from "react";
import { Link } from "react-router-dom";
import { Settings, LogOut } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../hooks/useTheme";

import {
  Grid2X2,
  PaintBucket,
  Palette,
  FileImage,
  Sliders,
} from "lucide-react";

export function Navbar() {
  const { user, signOut } = useAuth();
  const { theme, setTheme } = useTheme();

  const handleSignOut = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <div className="bg-base-200">
      {/* Top Navbar */}
      <div className="navbar bg-base-300 shadow-lg z-[2]">
        <div className="navbar-start">
          <Link to="/" className="text-xl font-bold pl-4 text-primary">
            FØRMUL8R
          </Link>
        </div>

        <div className="navbar-end gap-2">
          <Link to="/workspace/tiling" className="btn btn-ghost btn-sm">
            <Grid2X2 size={20} />
            <span className="hidden lg:inline">Tiling</span>
          </Link>

          <Link to="/workspace/patterning" className="btn btn-ghost btn-sm">
            <PaintBucket size={20} />
            <span className="hidden lg:inline">Patterning</span>
          </Link>

          <Link to="/workspace/styling" className="btn btn-ghost btn-sm">
            <Palette size={20} />
            <span className="hidden lg:inline">Styling</span>
          </Link>

          <Link to="/assets" className="btn btn-ghost btn-sm">
            <FileImage size={20} />
            <span className="hidden lg:inline">Assets</span>
          </Link>

          <Link to="/presets" className="btn btn-ghost btn-sm">
            <Sliders size={20} />
            <span className="hidden lg:inline">Presets</span>
          </Link>

          {user ? (
            <div className="dropdown dropdown-end">
              <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
                {user.photoURL ? (
                  <div className="w-8 rounded-full">
                    <img
                      src={user.photoURL}
                      alt={user.displayName || user.email || "User avatar"}
                    />
                  </div>
                ) : (
                  <div className="w-8 rounded-full bg-neutral text-neutral-content grid place-items-center">
                    <span className="text-xs">
                      {user.email?.[0].toUpperCase()}
                    </span>
                  </div>
                )}
              </label>
              <ul
                tabIndex={0}
                className="mt-3 z-[1] p-2 shadow menu menu-sm dropdown-content bg-base-300 rounded-box w-52"
              >
                <li>
                  <Link
                    to="/settings"
                    className="flex items-center px-4 py-2 hover:bg-base-100"
                  >
                    <Settings size={16} className="mr-2" />
                    <span>Settings</span>
                  </Link>
                </li>
                <li>
                  <button
                    onClick={handleSignOut}
                    className="flex items-center px-4 py-2 hover:bg-base-100 w-full"
                  >
                    <LogOut size={16} className="mr-2" />
                    <span>Sign Out</span>
                  </button>
                </li>
              </ul>
            </div>
          ) : (
            <Link to="/login" className="btn btn-ghost btn-sm">
              Sign In
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
